import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CcnService } from 'src/app/Service/ccn/ccn.service';
import { ICCNApproverInputModel, ICCNDisciplineInputModel, ICCNNoInputModel, ICCNInputModel, ICCNManhoursInputModel, ICCNDiscMembersInputModel, CCNManhoursOutputModel, ICCNDetailsInputModel, ICCNUpdateInputModel, ICCNByIdModel } from 'src/app/ViewModel/CCNModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { CcnPrintComponent } from './ccn-print-dialog/ccn-print/ccn-print.component';
import { GridComponent } from '@progress/kendo-angular-grid';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';
import { Subscription } from "rxjs";
import { Module } from 'src/app/Service/element-details.data.service';


const createFormGroup = (dataItem: any) => new FormGroup({
  'memberId': new FormControl(dataItem.memberId, [Validators.required]),
  'cCNStatus': new FormControl(dataItem.cCNStatus, [Validators.required]),
  'manHour': new FormControl(dataItem.manHour, [Validators.required, Validators.pattern('^[0-9]*$')]),
  'noOfDoc': new FormControl(dataItem.noOfDoc, [Validators.required, Validators.pattern('^[0-9]*$')]),
  'cCNRemarks': new FormControl(dataItem.cCNRemarks)
});

@Component({
  selector: 'app-change-control-create',
  templateUrl: './change-control-create.component.html',
  styleUrls: ['./change-control-create.component.css']
})
export class ChangeControlCreateComponent implements OnInit, OnDestroy {
  @ViewChild('MHGrid') MHGrid!: GridComponent;
  projectId!: number;
  memberId!: number;
  groupId!: number;
  project: string = '';
  initiatedBy: string = '';
  discCode: number = 0;
  discipline: string = '';
  approvers: string = '';
  public ccnTypeList: any[] = [];
  public MHList: any[] = [];
  public MHStatusList: any[] = [];
  public ccn: any;
  public ccnType!: number;
  public ccnNo: string = '';
  public ccnId: number = -1;
  public ccnRevNo: number = 0;
  public status:string="";
  public ccnInputForm: FormGroup = new FormGroup({
    txtTitle: new FormControl(),
    txtReason: new FormControl(),
    txtRef: new FormControl(),
    txtAction: new FormControl()
  });
  canSubmit: boolean = false;
  canPrint: boolean = false;
  canSave: boolean = true;
  currentEditRow: number = -1;
  formGroupList!: FormGroup;
  private editedRowIndex: number | undefined;
  private editedLine: any;
  UnsubscribeArray: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public inputCCN: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ChangeControlCreateComponent>,
    private commonService: CommonService,
    private notificationService: NotificationService,
    private elementdetailsService: ElementdetailsService,
    private ccnService: CcnService
  ) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.loadInitialData();
  }

  async loadInitialData() {
    var project = JSON.parse(this.commonService.getSessionStorageItem('projectObject'));
    this.project = this.commonService.getProjectCode() + ' - ' + project.projectDescription;
    this.ccnTypeList = await this.elementdetailsService.GetElementDetailsByDescList('CCN Type').toPromise();
    this.MHStatusList.push(
      { value: 1, description: 'Agreed' },
      { value: 2, description: 'Not Agreed' },
      { value: 3, description: 'NA' }
    );
    if (this.inputCCN.ccnId != -1) {
      this.ccnId = this.inputCCN.ccnId;
      this.ccnRevNo = this.inputCCN.ccnRevNo;
      let ccnInput: ICCNByIdModel = {
        cCNId: this.ccnId,
        cCNRevNo: +this.ccnRevNo
      }
      this.getCCN(ccnInput);
      this.getCCNDetails();
    }
    else {
      this.ccnType = this.inputCCN.ccnType;
      this.initiatedBy = this.commonService.getLoggedInUserName();
      this.getDiscipline(this.memberId);
    }
  }

  async getCCN(ccnInput: ICCNByIdModel) {
    let res = await this.ccnService.GetCCNById(ccnInput).toPromise();
    if (res != null && res.length > 0) {
      this.ccn = res[0];
      this.initiatedBy = this.ccn.originator;
      this.ccnNo = this.ccn.ccnNo;
      this.ccnType = this.ccn.ccType.toString();
     // this.canPrint = this.ccn.submitDate != null;
      if(this.inputCCN.status=='Pending for publish')
      this.canPrint = true;
      if(this.inputCCN.status=='Pending for Submission')
      this.canSubmit = true;
      this.ccnInputForm.get('txtTitle')?.setValue(this.ccn.ccnTitle);
      this.ccnInputForm.get('txtReason')?.setValue(this.ccn.ccnDescription);
      this.ccnInputForm.get('txtRef')?.setValue(this.ccn.ccnReference);
      this.ccnInputForm.get('txtAction')?.setValue(this.ccn.ccnAction);
      this.getDiscipline(this.ccn.createdBy);
    }
    else {
      this.notificationService.showToast("Invalid Data", "Warning");
    }
  }

  async getCCNDetails() {
    let ccnInput: ICCNManhoursInputModel = {
      projectId: this.projectId,
      cCNId: this.ccnId,
      groupId: this.groupId,
      cCNRevNo: this.ccnRevNo
    };
    this.MHList = await this.ccnService.GetCCNDetails(ccnInput).toPromise();
    if (this.MHList.length > 0) {
      if(this.MHList.some(x=>x.isActive==true))
        this.MHList=this.MHList.filter(x=>x.isActive==true);
      this.MHList.forEach(async x => {
        x.cCNStatus = x.ccnStatus;
        x.cCNStatusDesc = x.ccnStatusDesc;
        x.cCNRemarks = x.ccnRemarks;
        x.discCode = x.dedId;
        x.discDescription = x.dedDescription;
        x.Enable =  x.memberId && x.memberId>0 ?false:true;
        x.discMembers = await this.getDiscMembersDetails(x.dedId);
        x.notApplicable = x.memberId == 0;
      });
    }
    else {
      this.getManhourDetails();
    }
  }

  async getDiscipline(memberId: number) {
    let ccnInput: ICCNDisciplineInputModel = { projectId: this.projectId, memberId: memberId, groupId: this.groupId, module: Module.ScheduleDocument };
    let res = await this.ccnService.GetDisciplineDetails(ccnInput).toPromise();
    if (res.length > 0) {
      this.discCode = res[0]['dedId'];
      this.discipline = res[0]['dedDescription'];
      this.getApprovers();
    }
    else {
      this.notificationService.showToast("Logged In User is not mapped to any discipline.", "Warning");
      this.closeDialog();
    }
  }

  async getApprovers() {
    let ccnInput: ICCNApproverInputModel = { projectId: this.projectId, discCode: this.discCode, groupId: this.groupId, module: Module.ScheduleDocument };
    let res = await this.ccnService.GetApproverDetails(ccnInput).toPromise();
    res.forEach((element: { [x: string]: string; }) => {
      if (!this.approvers.includes(element['memberName'])) {
        if (this.approvers != '') {
          this.approvers += ', ';
        }
        this.approvers += element['memberName'];
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onValChange(value: number) {
    this.ccnType = value;
  }

  async generateCCN() {
    if (this.ccnInputForm.valid) {
      let ccnNoInput: ICCNNoInputModel = {
        projectId: this.projectId,
        cCType: this.ccnType,
        discCode: this.discCode
      }
      let res = await this.ccnService.GenerateCCNNo(ccnNoInput).toPromise();
      this.ccnNo = res[0].ccnNo;
      let ccnInput: ICCNInputModel = {
        projectId: this.projectId,
        cCNNo: this.ccnNo,
        cCNSNo: +res[0].sNo,
        cCNRevNo: 0,
        cCNTitle: this.getFormValue('txtTitle', this.ccnInputForm),
        cCNDesc: this.getFormValue('txtReason', this.ccnInputForm),
        cCNReference: this.getFormValue('txtRef', this.ccnInputForm),
        cCNAction: this.getFormValue('txtAction', this.ccnInputForm),
        disciplineDEDId: this.discCode,
        cCTypeDEDId: this.ccnType,
        userId: this.memberId
      }
      let ccninsert = this.ccnService.InsertCCN(ccnInput).subscribe((res: StandardOutputModel) => {
        if (res.successCode == 200) {
          this.ccnId = +res.result;
          this.getManhourDetails();
          this.notificationService.showToast(res.successMessage, "Success");
          this.canSubmit = true ;
        }
        else {
          this.notificationService.showToast(res.successMessage, "Warning");
          this.ccnNo = '';
        }
      });
      this.UnsubscribeArray.push(ccninsert);
    }
    else {
      this.notificationService.showToast("Mandatory Fields are Required", "Warning");
    }
  }

  async getManhourDetails() {
    let ccnInput: ICCNManhoursInputModel = {
      projectId: this.projectId,
      cCNId: this.ccnId,
      groupId: this.groupId,
      cCNRevNo: this.ccnRevNo
    };
    let res: CCNManhoursOutputModel[] = await this.ccnService.GetCCNManhours(ccnInput).toPromise();
    res.forEach(async x => x.discMembers = await this.getDiscMembersDetails(x.discCode));
    this.MHList = res;
    this.MHList.forEach(x =>{ x.notApplicable = false,
      x.Enable =  x.memberId && x.memberId>0?false:true;}
      );
  }

  async getDiscMembersDetails(discCode: number) {
    let ccnInput: ICCNDiscMembersInputModel = {
      projectId: this.projectId,
      groupId: this.groupId,
      discCode: discCode,
      cCNId: this.ccnId,
      cCNRevNo: 0
    };
    let members = await this.ccnService.GetCCNDiscMembers(ccnInput).toPromise();
    return members;
  }

  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  attachmentClick(data: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.projectId, ccnId: this.ccnId, revisionNo: "0", libraryName: FileUploadLibrary.CCNDocuments, createdBy: this.memberId, documents: [{ value: this.ccnId, text: this.ccnNo, revisionNo: "0" }], isEditable: false },
    });
  }

  async submitCCN() {
    let check = this.MHList.findIndex(x => (x.memberId == null || x.memberId == -2) && !x.notApplicable);
    // if (check != -1) {
    //   this.notificationService.showToast("Member is mandatory for Man hours", "Warning");
    //   return;
    // }
    // let check2 = this.MHList.findIndex(x => x.memberId != null && x.memberId != -2 && !x.notApplicable);
    // if (check2 == -1) {
    //   this.notificationService.showToast("Minimum one discipline required", "Warning");
    //   return;
    // }

    let ccnInput: ICCNUpdateInputModel = {
      cCNId: this.ccnId,
      cCNRevNo: 0,
      userId: this.memberId
    }
    let ccnsubmit = this.ccnService.SubmitCCN(ccnInput).subscribe((res: StandardOutputModel) => {
      //this.canPrint = true;
      this.showMessage(res);
    });
    this.UnsubscribeArray.push(ccnsubmit);
  }

  async publishCCN() {
    let ccnInput: ICCNUpdateInputModel = {
      cCNId: this.ccnId,
      cCNRevNo: 0,
      userId: this.memberId
    }
    let ccnpublish = this.ccnService.PublishCCN(ccnInput).subscribe((res: StandardOutputModel) => {
      this.showMessage(res);
    });
    this.UnsubscribeArray.push(ccnpublish);
  }

  printCCN() {
    let dialogRef = this.dialog.open(CcnPrintComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: this.ccnId, ccnRevNo: this.ccnRevNo, discCode: this.discCode }
    });
  }

  async saveCCN() {
    let check = this.MHList.findIndex(x => (x.memberId == null || x.memberId == -2) && !x.notApplicable);
    if (check != -1) {
      this.notificationService.showToast("Member is mandatory for Man hours", "Warning");
      return;
    }
    let check2 = this.MHList.findIndex(x => x.memberId != null && x.memberId != -2 && !x.notApplicable);
    if (check2 == -1) {
      this.notificationService.showToast("Minimum one discipline required", "Warning");
      return;
    }
    let ccnInput:any[]=[];
    this.MHList.forEach(async x => {
      if (x.memberId >= 0 && x.cCNStatus > 0 && (this.memberId==this.ccn.createdBy||x.memberId ==this.memberId)) {
        let obj: ICCNDetailsInputModel = {
          projectId: this.projectId,
          cCNId: this.ccnId,
          cCNNo: this.ccnNo,
          cCNRevNo: 0,
          dEDId: x.discCode,
          memberId: x.memberId,
          cCNStatus: x.cCNStatus,
          manHour: x.manHour,
          noOfDoc: x.noOfDoc,
          cCNRemarks: x.cCNRemarks,
          userId: this.memberId,
          createdBy: x.createdBy
        }
        ccnInput.push(obj)
      }

    });

    let ccninsertdetails = this.ccnService.InsertCCNDetails(ccnInput).subscribe((res: StandardOutputModel) => {
          
      this.canSubmit = !this.ccnId ?true:false;
      this.showMessage(res);
    });
    this.UnsubscribeArray.push(ccninsertdetails);
  }

  showMessage(res: StandardOutputModel) {
    if (res.successCode == 200) {
      this.notificationService.showToast(res.successMessage, "Success");
      this.closeDialog();
    }
    else {
      this.notificationService.showToast(res.successMessage, "Warning");
    }
  }

  memberChange(event: any, container: CCNManhoursOutputModel) {
    container.memberId = event.value;
    container.memberName = event.text;
    return container.memberId;
  }

  statusChange(event: any, container: CCNManhoursOutputModel) {
    container.cCNStatus = event.value;
    container.cCNStatusDesc = event.text;
    return container.cCNStatus;
  }

  notApplicableChange(event?: any) {
    if (event.checked || event == true) {
      this.MHList.forEach(async x => {
        if (x.notApplicable) {
          x.memberId = 0,
            x.cCNStatus = null,
            x.cCNStatusDesc = '',
            x.memberName = '',
            x.manHour = null,
            x.noOfDoc = null,
            x.cCNRemarks = ''
        }
      });
    }
  }

  public EditRowData(data: any): void {
    this.editedLine = Object.assign({}, data.dataItem);

    if (this.currentEditRow != -1) {
      this.MHGrid.closeRow(this.currentEditRow);
      this.editedRowIndex = data.rowIndex;
    }
    this.currentEditRow = data.rowIndex;
    if (!data.dataItem.notApplicable) {
      this.formGroupList = createFormGroup(data.dataItem);
      this.MHGrid.editRow(data.rowIndex);
    }
  }

  UpdateRowData(data: any) {
    data.sender.closeRow(data.rowIndex);
    if(this.ccnId!=-1 && (this.inputCCN.status=='Pending for manhour' || this.inputCCN.status=='Pending for publish'))
    {
      this.canSave = false;
    }
  }

  cancelRowData(data: any) {
    this.closeEditor(data.sender, data.rowIndex);
  }

  closeEditor(grid: { closeRow: (arg0: number) => void; }, rowIndex = this.editedRowIndex) {
    if (rowIndex) {
      grid.closeRow(rowIndex);
      this.MHList[rowIndex] = this.editedLine;
    }
    this.editedRowIndex = undefined;
    this.editedLine = undefined;
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }

}
